// extracted by mini-css-extract-plugin
export default {"wrapper":"i6BpuxEUnVclsAMmz3xE","resultsBlock":"KaSu3nkL__MD3Ig4_5QH"};